'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _reactRedux = require('react-redux');

var _lib = require('helpers/lib');

var _ReviewMobile = require('./ReviewMobile');

var _ReviewMobile2 = _interopRequireDefault(_ReviewMobile);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopReviewPage = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop,
    user: state.auth.user,
    reviewLoad: state.shops.reviewLoad
  };
}, (0, _extends3.default)({}, shopActions, {
  setPathName: _setup.setPathName
})), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopReviewPage, _Component);

  function ShopReviewPage(props) {
    (0, _classCallCheck3.default)(this, ShopReviewPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShopReviewPage.__proto__ || (0, _getPrototypeOf2.default)(ShopReviewPage)).call(this, props));

    _this.state = {
      showModalAlertLogin: false
    };

    _this.review = function (event) {
      event.preventDefault();
      if (_this.props.user) {
        _reactRouter.browserHistory.push('/' + _this.props.shop.handle + '/viet-danh-gia');
      } else {
        _this.setState({
          showModalAlertLogin: true
        });
      }
    };

    _this.handleCloseModalAlertLogin = function () {
      _this.setState({ showModalAlertLogin: false });
    };

    _this.lazyLoad = true;
    _this.onScroll = _this.onScroll.bind(_this);
    _this.redirectLogin = _this.redirectLogin.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ShopReviewPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getShopData(this.props.params.shopHandle);
      window.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.reviewLoad.reviews, nextProps.reviewLoad.reviews)) {
        this.lazyLoad = true;
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var beginTrigger = document.body.scrollHeight - window.innerHeight - 450;
      var endTrigger = document.body.scrollHeight - window.innerHeight - 350;
      if (beginTrigger < window.scrollY && window.scrollY < endTrigger && this.lazyLoad) {
        this.lazyLoad = false;
        this.props.getReview(this.props.reviewLoad.page + 1, this.props.shop._id);
      }
    }
  }, {
    key: 'redirectLogin',
    value: function redirectLogin() {
      this.props.setPathName(this.props.params.id);
      _reactRouter.browserHistory.push('/dang-nhap');
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ShopReviewPage.scss');
      var showModalAlertLogin = this.state.showModalAlertLogin;
      var _props = this.props,
          reviewLoad = _props.reviewLoad,
          shop = _props.shop;
      var reviews = reviewLoad.reviews,
          averagePoint = reviewLoad.averagePoint,
          good = reviewLoad.good,
          normal = reviewLoad.normal,
          bad = reviewLoad.bad,
          poor = reviewLoad.poor,
          total = reviewLoad.total;

      var reviewsRender = reviews ? reviews : [];
      var colorCode = (0, _lib.getColorRatingCode)(averagePoint);
      var stylePoint = {
        backgroundColor: colorCode
      };
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.ratingContainer },
          reviewsRender && _react2.default.createElement(
            'div',
            { className: styles.totalReview },
            'T\u1EEB ',
            total,
            ' \u0111\xE1nh gi\xE1'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.pointBox },
            _react2.default.createElement(
              'div',
              { className: styles.point, style: stylePoint },
              averagePoint === 0 ? '--' : averagePoint
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              '\u0110i\u1EC3m trung b\xECnh'
            )
          ),
          _react2.default.createElement('div', { className: styles.borderLeft }),
          _react2.default.createElement(
            'div',
            { className: styles.commentStatistic },
            _react2.default.createElement(
              'div',
              { className: styles.iconReviewRating },
              _react2.default.createElement('img', { src: '/icon/ic_good/ic_good.png' }),
              _react2.default.createElement(
                'div',
                null,
                good
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.iconReviewRating },
              _react2.default.createElement('img', { src: '/icon/ic_normal/ic_normal.png' }),
              _react2.default.createElement(
                'div',
                null,
                normal
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.iconReviewRating },
              _react2.default.createElement('img', { src: '/icon/ic_bad/ic_bad.png' }),
              _react2.default.createElement(
                'div',
                null,
                bad
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.iconReviewRating },
              _react2.default.createElement('img', { src: '/icon/ic_poor/ic_poor.png' }),
              _react2.default.createElement(
                'div',
                null,
                poor
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.reviewContainer },
          reviewsRender.map(function (review, index) {
            return _react2.default.createElement(
              'div',
              { className: styles.review },
              _react2.default.createElement(_ReviewMobile2.default, { shop: shop, review: review, key: index })
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.reviewBtnContainer },
          _react2.default.createElement(
            'button',
            { className: styles.reviewBtn, onClick: this.review },
            'VI\u1EBET \u0110\xC1NH GI\xC1 V\u1EC0 \u0110\u1ECAA \u0110I\u1EC2M N\xC0Y'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlertLogin,
            hide: this.handleCloseModalAlertLogin,
            className: 'modal-alert-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalAlertLogin
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'B\u1EA1n c\u1EA7n ph\u1EA3i \u0111\u0103ng nh\u1EADp \u0111\u1EC3 c\xF3 th\u1EC3 tham gia \u0111\xE1nh gi\xE1!'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                { className: styles.btnLogin, onClick: this.redirectLogin },
                '\u0110\u0103ng nh\u1EADp'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnCancel,
                  onClick: this.handleCloseModalAlertLogin
                },
                'Hu\u1EF7'
              )
            )
          )
        )
      );
    }
  }]);
  return ShopReviewPage;
}(_react.Component), _class2.propTypes = {
  // data
  shop: _react.PropTypes.object,
  params: _react.PropTypes.object,
  reviewLoad: _react.PropTypes.object,
  user: _react.PropTypes.object,
  // action
  getShopData: _react.PropTypes.func,
  getReview: _react.PropTypes.func,
  setPathName: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = ShopReviewPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/ShopReviewPage.js
// module id = 1593
// module chunks = 0